// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1HyyJ","vLegacy":"SelectSecondary_vLegacy__twEFZ","error":"SelectSecondary_error__2VR0r","disabled":"SelectSecondary_disabled__2jZk4"};